import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { AlertContext } from "../../../Context/AlertContextProvider";
import { AppContext } from "../../../Context/AppContextProvide";
import { PrintQueueContext } from "../../../Context/PrintQueueContextProvider";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useThirdPartyScript } from "../../../Util/loadExternalScript";
import { formatDttm, formatDate } from "../../../Util/timezone";
import QRcode from "qrcode.react";
import Barcode from "./Barcode";
import {
  updatePrintQueue,
  updateUserRole,
  likeProduct,
  unlikeProduct,
  likeProductStatus,
  getProductV2Data,
  getProductV2LikeSizes,
  getProductPageSettings,
  getAlternateProductSku,
  getCollectionProducts,
  getRelatedProducts,
  getDiscoveryProducts,
  getDuplicateFlags,
  getMergeCandidates,
  mergeCandidates,
  updateDuplicateCandidateStatus,
} from "../../../Actions";
import DuplicateMergeReview from "../../Admin/DuplicateDetection/DuplicateMergeReview";
import { Camera, Casino, Close, Edit, Equalizer, ExpandMore, Favorite, Info, Launch, MoodBad, People, Print, Settings, Visibility, VisibilityOff } from "@material-ui/icons";
import ProductStatsDialog from "../ProductStatsDialog";
import CreateLeadForm from "../../LeadManagement/CreateLeadForm";
import ScanningModal from "../../LandingPage/Scanner/ScanningModal";
import { Accordion, AccordionDetails, AccordionSummary, Backdrop, Button, Card, CardContent, CardMedia, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Grid, MenuItem, Paper, Select, TextField, Tooltip, Typography } from "@material-ui/core";
import SignInAlert from "../SignInAlert";
import SampleCheckouts from "./SampleCheckouts";
import UpdateProductDialog from "./UpdateProductDialog";
import ProductLinkList from "./productLinkList";
import SlotMachine from "../../Tradeshow/slotMachine";
import FlowModal from "../../Admin/CustomCalculations/FlowModal";

export default function ProductV2(props) {
  const { productId } = useParams();
  const { search } = useLocation();
  const { user, roleId, roles, setRoleId, isLoggedOut } = useContext(AppContext);
  const { setUpdate } = useContext(PrintQueueContext);
  const { handleAlertOpen, setMessageType, setMessage } = useContext(AlertContext);
  const fetchTimeoutRef = useRef(null);
  const hasFetchedProductRef = useRef(false);
  // Holds a pending "show the error screen" timer. Auth/role state can still be
  // settling right after a QR scan or a login, which briefly makes the product
  // request fail before a corrected request fires. We defer the error UI so a
  // self-correcting fetch can cancel it instead of flashing "something went wrong".
  const errorTimeoutRef = useRef(null);

  const localRoleId = sessionStorage.getItem('roleId') ?? "";
  const locationId = search?.split("=")[1] ?? null;

  const [isProductDataLoading, setIsProductDataLoading] = useState(true);
  const [hasLoadingError, setHasLoadingError] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [path, setPath] = useState();
  const [selectedProductUUID, setSelectedProductUUID] = useState();
  const [likeSizeProducts, setLikeSizeProducts] = useState([]);
  const [productData, setProductData] = useState();
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [basisOptions, setBasisOptions] = useState([]);
  const [fobOriginOptions, setFOBOriginOptions] = useState([]);
  const [pageConfig, setPageConfig] = useState();
  const [role, setRole] = useState();
  const [productSkuLikes, setProductSkuLikes] = useState([]);
  const [isProductSkuLiked, setIsProductSkuLiked] = useState(true);
  const [selectedBasisOption, setSelectedBasisOption] = useState("");
  const [selectedFOBOriginOption, setSelectedFOBOriginOption] = useState("");
  const [productDisclaimer, setProductDisclaimer] = useState("");
  const [taxDisclaimer, setTaxDisclaimer] = useState("");
  const [showScannerModal, setShowScannerModal] = useState(false);
  const [showStatsDialog, setShowStatsDialog] = useState(false);
  const [showUpdateProductDialog, setShowUpdateProductDialog] = useState(false);
  const [showLeadDialog, setShowLeadDialog] = useState(false);
  const [showSignInAlert, setShowSignInAlert] = useState(false);
  const [showInternalFunctionsModal, setShowInternalFunctionsModal] = useState(false);
  const [sizeEstimate, setSizeEstimate] = useState(0);
  const [roomvoToggle, setRoomvoToggle] = useState(false);
  const [isRoomCalcAllowed, setIsRoomCalcAllowed] = useState(false);
  const [isCheckoutAllowed, setIsCheckoutAllowed] = useState(false);
  const [isFavAllowed, setIsFavAllowed] = useState(false);
  const [requireOptionSelection, setRequireOptionSelection] = useState(false);
  const [showCustomerView, setShowCustomerView] = useState(false);
  const [showVegasMarketing, setShowVegasMarketing] = useState(true);
  const [isSlotModalOpen, setIsSlotModalOpen] = useState(false);
  const [isCalcViewModalOpen, setIsCalcViewModalOpen] = useState(false);
  const [useCustomCalcFunctions, setUseCustomCalcFunctions] = useState(false);
  const [showDiscovery, setShowDiscovery] = useState(false);
  const [showRelatedProducts, setShowRelatedProducts] = useState(false);
  const [duplicateFlag, setDuplicateFlag] = useState(null);
  const [dupProductA, setDupProductA] = useState(null);
  const [dupProductB, setDupProductB] = useState(null);
  const [dupKeeperUuid, setDupKeeperUuid] = useState('');
  const [dupMerging, setDupMerging] = useState(false);
  const [dupDialogOpen, setDupDialogOpen] = useState(false);

  const { isLoaded: isRoomvoLoaded, error: roomvoError } = useThirdPartyScript(roomvoToggle ? "https://cdn.roomvo.com/static/scripts/b2b/showroompricing.js" : "", "roomvo", true, "text/javascript");
  const hasMultipleDistributors = !options?.every(option => option.distributor === options[0]?.distributor) ?? false;
  const hasDiscontinuedOptions = !options?.filter(option => (selectedBasisOption === 'none' && !option.basis_cd) || option.basis_cd === selectedBasisOption).every(option => !option.is_discontinued);

  useEffect(() => {
    // All page-level toggles/disclaimers now come back in ONE request instead of
    // ~11 separate round trips that each grabbed a connection from the small DB
    // pool and starved the product/price query on first (QR-scan) load.
    async function loadPageSettings() {
      try {
        const { data } = await getProductPageSettings();
        setRequireOptionSelection(!!parseInt(data.requireOptionSelection));
        setRoomvoToggle(parseInt(data.roomvoToggle) === 1);
        setShowVegasMarketing(Number(data.showVegasMarketing) === 1);
        setUseCustomCalcFunctions(Number(data.useCustomCalcFunctions) === 1);
        setShowDiscovery(Number(data.showProductDiscovery) === 1);
        setShowRelatedProducts(Number(data.showRelatedProducts) === 1);
        setIsCheckoutAllowed(!!parseInt(data.prodCheckout?.[0]?.app_value));
        setIsFavAllowed(!!parseInt(data.prodFavorite?.[0]?.app_value));
        setIsRoomCalcAllowed(!!parseInt(data.roomCalc?.[0]?.active));
        setTaxDisclaimer(data.taxDisclaimer?.[0]?.disclaimer ?? undefined);
        setProductDisclaimer(data.productDisclaimer?.[0]?.product_disclaimer ?? undefined);
      } catch {
        setRequireOptionSelection(false);
        setRoomvoToggle(false);
        setShowVegasMarketing(false);
        setUseCustomCalcFunctions(false);
        setShowDiscovery(false);
        setShowRelatedProducts(false);
        setIsCheckoutAllowed(false);
        setIsFavAllowed(false);
        setIsRoomCalcAllowed(false);
        setTaxDisclaimer(undefined);
        setProductDisclaimer(undefined);
      }
    }

    loadPageSettings();
  }, [])

  const getProductSkuLikes = async () => {
    if (isLoggedOut) {
      setProductSkuLikes([]);
      setIsProductSkuLiked(false);
      
      return;
    }

    await likeProductStatus(productId)
      .then((result) => {
        setProductSkuLikes([ ...result.data.status ]);

        if (selectedOption) {
          const isLiked = result.data.status?.map(l => l.product_sku_uuid)?.includes(selectedOption.product_sku_uuid) ?? false;

          setIsProductSkuLiked(isLiked);
        } else {
          setIsProductSkuLiked(false);
        }
      })
      .catch((err) => {
        setProductSkuLikes([]);
        setIsProductSkuLiked(false);
      });
  }

  useEffect(() => {
    async function changeRole(roleId) {
      await updateUserRole(roleId)
        .then(() => {
          sessionStorage.setItem('roleId', String(roleId));
        })
        .catch((err) => {

        });
    }

    let productPath = `product/v2/customer/${productId}${search}`;

    if (!showCustomerView && !isLoggedOut && user?.access_type_cd !== 'c') {
      // The internal route is role-scoped. Right after a login the role can still
      // be settling (roleId/localRoleId/user.role_id all empty for a beat) — firing
      // product/v2/{id}/undefined then 500s and briefly flashed the error screen.
      // Only switch to the internal path once a real role resolves; until then hold
      // the customer path. This effect re-runs when roleId / user settle and swaps.
      const effectiveRole = roleId || localRoleId || user?.role_id;

      if (effectiveRole) {
        // Only persist the role when it actually changed. Reading sessionStorage
        // here (rather than via a dependency) keeps this effect from re-triggering
        // itself and firing a redundant POST on every render/remount.
        if (roleId && String(roleId) !== sessionStorage.getItem('roleId')) {
          changeRole(roleId);
        }

        productPath = `product/v2/${productId}/${effectiveRole}${search}`;
      }
    }

    if (productPath && productPath !== path) setPath(productPath);

    getProductSkuLikes();
    // localRoleId is derived from sessionStorage on each render and is intentionally
    // NOT a dependency — including it made this effect self-triggering.
  }, [search, roleId, user?.access_type_cd, isLoggedOut, showCustomerView])

  useEffect(() => {
    const abortController = new AbortController();

    // Deferred size selector: fetched in the background after the price card paints
    // so it isn't blocked by the N per-size pricing queries this used to run inline.
    // Returns only the other sizes; we prepend the already-loaded primary product.
    async function loadLikeSizes(currentPath, primaryProduct) {
      if (!primaryProduct?.product_uuid) {
        setLikeSizeProducts([]);
        return;
      }

      // Insert the /like-sizes suffix before any query string.
      const [base, query] = currentPath.split('?');
      const likeSizesPath = `${base}/like-sizes${query ? `?${query}` : ''}`;

      await getProductV2LikeSizes(likeSizesPath, { signal: abortController.signal })
        .then((result) => {
          const sizes = result.data.like_sizes ?? [];

          if (!sizes.length) {
            setLikeSizeProducts([]);
            return;
          }

          const likeSizesArr = [ primaryProduct, ...sizes ];

          likeSizesArr.sort((a, b) => {
            if (a.size_cd < b.size_cd) {
              return -1;
            } else if (a.size_cd > b.size_cd) {
              return 1;
            } else {
              return 0;
            }
          });

          setLikeSizeProducts([ ...likeSizesArr ]);
        })
        .catch((err) => {
          if (abortController.signal.aborted || err?.code === "ERR_CANCELED" || err?.name === "CanceledError") {
            return;
          }

          setLikeSizeProducts([]);
        });
    }

    async function getProduct(path) {
      if (!productData?.product_uuid) setIsProductDataLoading(true);

      // A new attempt supersedes any pending error from a prior failed fetch.
      if (errorTimeoutRef.current) {
        clearTimeout(errorTimeoutRef.current);
        errorTimeoutRef.current = null;
      }

      await getProductV2Data(path, { signal: abortController.signal })
        .then((result) => {
          setProductData({ ...result.data.product });
          setSelectedProductUUID(result.data.product.product_uuid);
          setBasisOptions([ ...result.data.product.basis_options ]);
          setFOBOriginOptions([ ...result.data.product.fob_origin_options ]);
          setPageConfig({ ...result.data.page_config });
          setRole({ ...result.data.role });

          // like_sizes no longer ships in this response — load it lazily, and only
          // when the tenant combines sizes, so the price card renders immediately.
          if (result.data.page_config?.should_combine_sizes) {
            loadLikeSizes(path, result.data.product);
          } else {
            setLikeSizeProducts([]);
          }

          if (result.data.product.basis_options?.find(option => option.basis_cd === "CT")) {
            setSelectedBasisOption("CT");
          } else {
            setSelectedBasisOption(result.data.product.basis_options[0]?.basis_cd || "none");
          }

          setSelectedFOBOriginOption(result.data.product.fob_origin_default || result.data.product.fob_origin_options[0]?.fob_origin || "unspecified");

          setHasLoadingError(false);
          setIsProductDataLoading(false);
        })
        .catch((err) => {
          // A superseded request was cancelled — ignore it and let the newer one win.
          if (abortController.signal.aborted || err?.code === "ERR_CANCELED" || err?.name === "CanceledError") {
            return;
          }

          // Don't flash the error screen immediately. On a QR scan / fresh login the
          // request can fail transiently while auth + role settle, then a corrected
          // request succeeds ~half a second later. Keep the loader up and only commit
          // to the error UI if nothing has superseded this failure after a grace
          // period (a later success clears errorTimeoutRef above).
          if (errorTimeoutRef.current) clearTimeout(errorTimeoutRef.current);
          errorTimeoutRef.current = setTimeout(() => {
            setSelectedProductUUID(undefined);
            setProductData(undefined);
            setOptions([]);
            setLikeSizeProducts([]);
            setPageConfig(undefined);
            setRole(undefined);
            setSelectedOption(undefined);
            setSelectedBasisOption("");
            setSelectedFOBOriginOption("");
            setHasLoadingError(true);
            setIsProductDataLoading(false);

            if (['401', '500'].includes(err.status)) sessionStorage.clear();
          }, 1200);
        });
    }

    if (path) {
      if (fetchTimeoutRef?.current) clearTimeout(fetchTimeoutRef.current);

      // Price-card first: fire the very first product fetch immediately so the
      // price renders as fast as possible. Only debounce subsequent path changes
      // (role/option switches) to coalesce rapid updates.
      if (hasFetchedProductRef.current) {
        fetchTimeoutRef.current = setTimeout(() => getProduct(path), 100);
      } else {
        hasFetchedProductRef.current = true;
        getProduct(path);
      }
    }

    setRefreshPage(false);

    return () => {
      if (fetchTimeoutRef?.current) clearTimeout(fetchTimeoutRef.current);
      if (errorTimeoutRef?.current) {
        clearTimeout(errorTimeoutRef.current);
        errorTimeoutRef.current = null;
      }
      abortController.abort();
    };
  }, [path, refreshPage])

  const isInternalUser = ['a', 'rw', 'ro'].includes(user?.access_type_cd);

  useEffect(() => {
    if (!selectedProductUUID || !isInternalUser || showCustomerView) return;
    getDuplicateFlags([selectedProductUUID])
      .then((res) => {
        const flag = (res.data.flags || {})[selectedProductUUID];
        setDuplicateFlag(flag || null);
      })
      .catch(() => {});
  }, [selectedProductUUID, showCustomerView]);

  const handleDuplicateReview = () => {
    getMergeCandidates([duplicateFlag.product_uuid_a, duplicateFlag.product_uuid_b])
      .then((res) => {
        const list = res.data.data || [];
        setDupProductA(list.find((p) => p.product_uuid === duplicateFlag.product_uuid_a) || list[0]);
        setDupProductB(list.find((p) => p.product_uuid === duplicateFlag.product_uuid_b) || list[1]);
        setDupKeeperUuid('');
        setDupDialogOpen(true);
      });
  };

  const handleDupClose = () => {
    setDupDialogOpen(false);
    setDupKeeperUuid('');
  };

  const handleDupMergeConfirm = () => {
    if (!dupKeeperUuid || !duplicateFlag) return;
    const loserUuid = dupKeeperUuid === duplicateFlag.product_uuid_a
      ? duplicateFlag.product_uuid_b
      : duplicateFlag.product_uuid_a;
    setDupMerging(true);
    mergeCandidates(dupKeeperUuid, [loserUuid])
      .then(() => updateDuplicateCandidateStatus(duplicateFlag.id, 'merged'))
      .then(() => {
        setDuplicateFlag(null);
        handleDupClose();
        window.location.reload();
      })
      .finally(() => setDupMerging(false));
  };

  const handleDupDismiss = () => {
    if (!duplicateFlag) return;
    updateDuplicateCandidateStatus(duplicateFlag.id, 'dismissed').then(() => {
      setDuplicateFlag(null);
      handleDupClose();
    });
  };

  useEffect(() => {
    if (!likeSizeProducts?.length) return;

    const selectedProduct = likeSizeProducts.find(p => p.product_uuid === selectedProductUUID);

    // TODO: Trigger an error modal or something here if the product is not found
    if (!selectedProduct) return;

    setProductData({ ...selectedProduct });
    setBasisOptions([ ...selectedProduct.basis_options ]);
    setFOBOriginOptions([ ...selectedProduct.fob_origin_options ]);
    
    if (selectedProduct.basis_options?.find(option => option.basis_cd === "CT")) {
      setSelectedBasisOption("CT");
    } else {
      setSelectedBasisOption(selectedProduct.basis_options[0]?.basis_cd || "none");
    }

    setSelectedFOBOriginOption(selectedProduct.fob_origin_default || selectedProduct.fob_origin_options[0]?.fob_origin || "unspecified");
  }, [selectedProductUUID])

  useEffect(() => {
    setIsProductDataLoading(true);
  }, [showCustomerView])

  useEffect(() => {
    let filteredOptions = productData?.options ?? [];

    if (showCustomerView) {
      const newestCostRecord = productData?.options?.reduce((acc, curr) => {
        return new Date(acc.last_modified_dttm).getTime() < new Date(curr.last_modified_dttm).getTime() ? curr : acc;
      });

      filteredOptions = filteredOptions?.filter(o => o.distributor === newestCostRecord.distributor);
    }

    if (selectedBasisOption === undefined || selectedFOBOriginOption === undefined) {
      setOptions(filteredOptions?.length ? [ ...filteredOptions ] : []);
      setSelectedOption(filteredOptions?.length ? { ...filteredOptions[0] } : undefined);

      return;
    }

    filteredOptions = productData?.options?.filter(option => (selectedFOBOriginOption === 'unspecified' && !option.fob_origin) || option.fob_origin === selectedFOBOriginOption) ?? [];
    filteredOptions = filteredOptions?.filter(option => (selectedBasisOption === 'none' && !option.basis_cd) || option.basis_cd === selectedBasisOption) ?? []

    filteredOptions?.sort((a, b) => {
      if (a.is_discontinued && !b.is_discontinued) return 1;

      if (!a.is_discontinued && b.is_discontinued) return -1;

      if (a.color_name < b.color_name) {
        return -1;
      } else if (a.color_name > b.color_name) {
        return 1;
      } else {
        return 0;
      }
    })

    setOptions(filteredOptions?.length ? [ ...filteredOptions ] : []);

    if (requireOptionSelection && filteredOptions.length > 1) {
      setSelectedOption(undefined);
      return;
    }

    setSelectedOption(filteredOptions.length ? { ...filteredOptions[0] } : undefined);
  }, [selectedBasisOption, basisOptions, selectedFOBOriginOption, fobOriginOptions])

  useEffect(() => {
    setSizeEstimate(0);

    if (selectedOption?.product_sku_uuid) {
      const isLiked = productSkuLikes?.map(l => l.product_sku_uuid)?.includes(selectedOption.product_sku_uuid) ?? false;

      setIsProductSkuLiked(isLiked);
    } else {
      setIsProductSkuLiked(false);
    }
  }, [selectedOption?.product_sku_uuid, productSkuLikes])

  const handleUpdatePrintQueue = async (product_uuid) => {
    await updatePrintQueue([product_uuid])
      .then(() => {
        setUpdate(true);
        setMessageType('success');
        setMessage('Print Queue Updated');
        handleAlertOpen();
      })
      .catch((err) => {
        setMessageType('error');
        setMessage('Error Updating Print Queue');
        handleAlertOpen();
      });
  };

  const onClickfavorite = async (product_uuid, product_sku) => {
    if (isLoggedOut) {
      setShowSignInAlert(true);

      return;
    }

    if (isProductSkuLiked) {
      await unlikeProduct(product_uuid, product_sku)
        .then(() => {
          setIsProductSkuLiked(false);
        })
        .catch((err) => {
          
        });

      await getProductSkuLikes();

      return;
    }

    await likeProduct(product_uuid, product_sku, locationId)
      .then(() => {
        setIsProductSkuLiked(true);
      })
      .catch((err) => {
        
      });

    await getProductSkuLikes();
  };

  const openRoomvoVisualizer = async (e) => {
    e.preventDefault();
    
    if (!selectedOption?.product_sku_uuid) return;

    let alternate_product_sku;

    try {
      const productSkuResults = await getAlternateProductSku(selectedOption?.product_sku_uuid);
      alternate_product_sku = productSkuResults.data?.alternate_product_sku;
    } catch (err) {}
    
    window.roomvo?.startStandaloneVisualizer?.('', alternate_product_sku || selectedOption.alternate_product_sku || selectedOption.product_sku);
  }

  const getFormattedExternalUrl = (url) => {
    if (!/^(http|https):\/\//.test(url)) {
      return `https://${url}`;
    }

    return url;
  }

  if (hasLoadingError) {
    return (
      <Dialog open={true} >
        <DialogContent style={{textAlign: "center", padding: "20px", backgroundColor: "#fff3f2", maxWidth: "450px"}}>
          <MoodBad style={{fontSize: "12rem", color: "#f44336"}}/>
          <Typography variant="h4" style={{color: "#f44336", marginBottom: "20px"}}><b>Oops, something went wrong!</b></Typography>
          <Typography variant="body1">It looks like there was an issue loading the product page. Please try refreshing the page or contacting a system admin for more information.</Typography>
          <Button 
            variant="contained" 
            size="medium"
            onClick={() => window.location.reload()}
            style={{margin: "40px auto 20px", backgroundColor: "#FFFFFF"}}
          >
            Refresh Page
          </Button>
        </DialogContent>
      </Dialog>
    )
  }

  if (isProductDataLoading) {
    return (
      <Backdrop open={true} style={{color: "#28C4FC", backgroundColor: "#142E3E"}}>
        <div style={{textAlign: "center"}}>
          <CircularProgress size={100} style={{color: "#28C4FC", marginBottom: "20px"}}/>
          { productData?.product_uuid ? (
              <Typography variant="h4" style={{color: "#28C4FC"}}>{showCustomerView ? `Switching to ${role?.role_name ?? 'Retail Customer'} View...` : 'Switching To Internal View...'}</Typography>
            ) : (
              <Typography variant="h4" style={{color: "#28C4FC"}}>Loading Product Data...</Typography>
            )
          }
        </div>
      </Backdrop>
    )
  }

  let currentListPrice = 0;
  let currentListPriceStr;
  let currentCostStr;
  let currentBaseCostStr;
  let currentListPromoPrice = 0;
  let currentListPromoPriceStr;
  let currentBasePromoCostStr;
  let currentPromoCostStr;

  if (selectedOption) {
    const listPrice = selectedOption.pricing.retail_price?.toFixed(2);

    if (selectedOption.is_discontinued) {
      currentListPrice = currentListPriceStr = currentCostStr = currentBaseCostStr = 'Discontinued';
    } else if (selectedOption.is_ask_for_price) {
      currentListPrice = currentListPriceStr = currentCostStr = currentBaseCostStr = 'Ask For Price';
    } else if (selectedOption.is_call_for_price) {
      currentListPrice = currentListPriceStr = currentCostStr = currentBaseCostStr = 'Call For Price';
    } else if (selectedOption.is_promo_active) {
      currentListPrice = listPrice;
      currentListPriceStr = `$${listPrice} / ${selectedOption.uom}`;
      currentCostStr = ['a', 'rw'].includes(user?.access_type_cd) && !showCustomerView && selectedOption.pricing.cost ? `$${selectedOption.pricing.cost?.toFixed(2)} / ${selectedOption.uom}` : '';
      currentBaseCostStr = ['a'].includes(user?.access_type_cd) && !showCustomerView && selectedOption.pricing.base_cost ? `$${selectedOption.pricing.base_cost?.toFixed(2)} / ${selectedOption.uom}` : '';

      const promoPrice = selectedOption.promotion_pricing.retail_price?.toFixed(2);

      currentListPromoPrice = promoPrice;
      currentListPromoPriceStr = `$${promoPrice} / ${selectedOption.uom}`;
      currentPromoCostStr = ['a', 'rw'].includes(user?.access_type_cd) && !showCustomerView && selectedOption.promotion_pricing.cost ? `$${selectedOption.promotion_pricing.cost?.toFixed(2)} / ${selectedOption.uom}` : '';
      currentBasePromoCostStr = ['a'].includes(user?.access_type_cd) && !showCustomerView && selectedOption.promotion_pricing.base_cost ? `$${selectedOption.promotion_pricing.base_cost?.toFixed(2)} / ${selectedOption.uom}` : '';
    } else {
      currentListPrice = listPrice;
      currentListPriceStr = `$${listPrice} / ${selectedOption.uom}`;
      currentCostStr = ['a', 'rw'].includes(user?.access_type_cd) && !showCustomerView && selectedOption.pricing.cost ? `$${selectedOption.pricing.cost?.toFixed(2)} / ${selectedOption.uom}` : '';
      currentBaseCostStr = ['a'].includes(user?.access_type_cd) && !showCustomerView && selectedOption.pricing.base_cost ? `$${selectedOption.pricing.base_cost?.toFixed(2)} / ${selectedOption.uom}` : '';
    }
  } else {
    currentListPriceStr = currentCostStr = currentBaseCostStr = options?.length ? 'No Option Selected' : 'No Pricing Is Available for This Selection';
  }

  let roundedSizeEstimate = sizeEstimate || 0;
  let isEstimateRounded = false;
  
  if (!!selectedOption?.selling_unit_quantity && sizeEstimate) {
    const extra = selectedOption.selling_unit_quantity - (sizeEstimate % selectedOption.selling_unit_quantity);
    roundedSizeEstimate = selectedOption.selling_unit_quantity !== extra ? sizeEstimate + extra : sizeEstimate;
    isEstimateRounded = selectedOption.selling_unit_quantity !== extra ? true : false;
  }

  return (
    <div style={{margin: "100px 10px 20px"}}>
      <Paper elevation={15} style={{padding: "10px 10px 20px"}}>
        {isInternalUser && !showCustomerView && duplicateFlag && (
          <div style={{
            background: '#fff8e1',
            border: '1px solid #f9a825',
            borderRadius: 6,
            padding: '10px 16px',
            marginBottom: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            flexWrap: 'wrap',
          }}>
            <span style={{ fontSize: 18 }}>⚠️</span>
            <span style={{ flex: 1, fontSize: 13, color: '#5d4037' }}>
              Potential duplicate detected — {(Number(duplicateFlag.score) * 100).toFixed(0)}% confidence match with another product.
            </span>
            <Button size="small" variant="contained" style={{ backgroundColor: '#FF682C', color: '#fff' }} onClick={handleDuplicateReview}>
              Review
            </Button>
            <Button size="small" variant="outlined" onClick={handleDupDismiss}>
              Not a Duplicate
            </Button>
          </div>
        )}
        <Grid container spacing={2} style={{rowGap: "20px"}}>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} style={{border: "2px solid #00000017", padding: "10px"}}>
              { pageConfig?.show_location && productData?.location_name ? (
                  <Typography variant="body1">
                    {productData?.location_name}
                  </Typography>
                ) : undefined
              }
              <Typography variant="h6" style={{marginBottom: "30px"}}>
                <b>{productData?.private_trade_name ? productData?.private_trade_name : productData?.trade_name}</b>
              </Typography>

              <Typography variant="h6">
                <b>{role?.role_prefix === 1 ? role.role_name : undefined} Price</b>
              </Typography>
              <Typography variant={!selectedOption || selectedOption?.is_discontinued || selectedOption?.is_ask_for_price || selectedOption?.is_call_for_price || selectedOption?.is_promo_active ? "h4" : "h3"} color={selectedOption?.is_discontinued || !options?.length ? "error" : "inherit"} style={{marginBottom: "10px", textDecoration: selectedOption?.is_promo_active && !selectedOption?.is_ask_for_price ? "line-through" : "none", textDecorationColor: "rgba(0,0,0,0.65)"}}>
                <b>{currentListPriceStr}</b>
              </Typography>
              <Typography variant="h3" color="error" style={{marginBottom: "10px"}}>{selectedOption?.is_promo_active ? currentListPromoPriceStr : undefined}</Typography>
              <Typography variant="subtitle2" style={{marginBottom: "10px"}}>{selectedOption?.is_discontinued ? `on ${selectedOption?.effective_end_date}` : undefined}</Typography>
              <Typography variant="subtitle2" style={{marginBottom: "10px"}}>{selectedOption?.is_promo_active && !selectedOption?.is_ask_for_price ? `Promo active through ${selectedOption?.promotion_pricing?.effective_end_date ? formatDate(selectedOption?.promotion_pricing?.effective_end_date, { fallback: "unknown date" }) : "unknown date"}`: undefined}</Typography>
              <Typography variant="subtitle2" style={{marginBottom: "30px"}}>
                <i>{taxDisclaimer}</i>
              </Typography>

              { !showCustomerView && roles?.length > 1 ? (
                  <>
                    <Typography><b>Roles</b></Typography>
                    <Select
                      value={roleId ?? localRoleId ?? user?.role_id}
                      onChange={(e) => setRoleId(e.target.value)} 
                      variant="filled"
                      SelectDisplayProps={{
                        style: {paddingTop: "10px"}
                      }}
                      style={{marginBottom: "15px", width: "100%", maxWidth: "300px"}}
                    >
                      { 
                        roles?.map(role => {
                          return (
                            <MenuItem key={role.role_id} value={role.role_id}>
                              {role.role_name}
                            </MenuItem>
                          )
                        })
                      }
                    </Select>
                  </>
                ) : undefined
              }

              { likeSizeProducts?.length ? (
                  <>
                    <Typography><b>Sizes</b></Typography>
                    <Select
                      value={selectedProductUUID}
                      onChange={(e) => setSelectedProductUUID(e.target.value)} 
                      variant="filled"
                      SelectDisplayProps={{
                        style: {paddingTop: "10px"}
                      }}
                      style={{marginBottom: "15px", width: "100%", maxWidth: "300px"}}
                    >
                      { 
                        likeSizeProducts?.map(product => {
                          return (
                            <MenuItem key={product.product_uuid} value={product.product_uuid}>
                              {product.size_cd || 'No Size Code'}
                            </MenuItem>
                          )
                        })
                      }
                    </Select>
                  </>
                ) : undefined
              }

              { !showCustomerView && fobOriginOptions.length > 1 ? (
                  <>
                    <Typography><b>FOB Origins</b></Typography>
                    <Select
                      value={selectedFOBOriginOption}
                      onChange={(e) => setSelectedFOBOriginOption(e.target.value)} 
                      variant="filled"
                      SelectDisplayProps={{
                        style: {paddingTop: "10px"}
                      }}
                      style={{marginBottom: "15px", width: "100%", maxWidth: "300px"}}
                      displayEmpty
                    >
                      { 
                        fobOriginOptions?.map(option => {
                          return (
                            <MenuItem key={option.fob_origin} value={option.fob_origin || 'unspecified'}>
                              {option.fob_origin || 'No Specified FOB Origin'}
                            </MenuItem>
                          )
                        })
                      }
                    </Select>
                  </>
                ) : !showCustomerView && fobOriginOptions[0]?.fob_origin ? (
                  <>
                    <Typography><b>FOB Origin</b></Typography>
                    <Typography style={{marginBottom: "15px"}}>{fobOriginOptions[0]?.fob_origin}</Typography>
                  </>
                ) : undefined
              }

              { basisOptions.length > 1 ? (
                  <>
                    <Typography><b>Pricing Types</b></Typography>
                    <Select
                      value={selectedBasisOption}
                      onChange={(e) => setSelectedBasisOption(e.target.value)} 
                      variant="filled"
                      SelectDisplayProps={{
                        style: {paddingTop: "10px"}
                      }}
                      style={{marginBottom: "15px", width: "100%", maxWidth: "300px"}}
                      displayEmpty
                    >
                      { 
                        basisOptions?.map(option => {
                          return (
                            <MenuItem key={option.basis_cd} value={option.basis_cd || 'none'}>
                              {option.basis_cd ? `(${option.basis_cd})` : ''} {option.basis || 'No Basis Code'}
                            </MenuItem>
                          )
                        })
                      }
                    </Select>
                  </>
                ) : basisOptions[0]?.basis_cd ? (
                  <>
                    <Typography><b>Pricing Type</b></Typography>
                    <Typography style={{marginBottom: "15px"}}>({basisOptions[0]?.basis_cd}) {basisOptions[0]?.basis}</Typography>
                  </>
                ) : undefined
              }

              { options.length > 1 ? (
                  <>
                    <Typography>
                      <b>Color Options</b>
                      { hasDiscontinuedOptions ? (
                          <Tooltip 
                            title={
                              <Typography variant="subtitle2">Some options discontinued</Typography> 
                            }
                            aria-label="Some options discontinued"
                            placement="top"
                          >
                            <Info style={{display: "inline-block", verticalAlign: "top", marginLeft: "5px", color: "#f44336"}}/>
                          </Tooltip>
                        ) : undefined
                      }
                    </Typography>
                    <Select
                      value={selectedOption?.cost_id ?? ""}
                      onChange={(e) => {
                        const option = options?.find(option => option.cost_id === e.target.value);

                        setSelectedOption({ ...option });
                      }} 
                      variant="filled"
                      SelectDisplayProps={{
                        style: {paddingTop: "10px"}
                      }}
                      style={{width: "100%", maxWidth: "300px"}}
                      displayEmpty
                    >
                      { requireOptionSelection ? (
                          <MenuItem value={""} disabled>
                            Please select one of the following options
                          </MenuItem> 
                        ) : undefined
                      }
                      { 
                        options?.map(option => {

                          let optionDetails = "";

                          if (option.pricing.retail_price) {
                            optionDetails = "$" + option.pricing.retail_price?.toFixed(2);
                          }

                          if (option.is_promo_active) {
                            optionDetails = "$" + option.promotion_pricing.retail_price?.toFixed(2) + " (Promo)";
                          }

                          if (option.is_discontinued) {
                            optionDetails = "Discontinued";
                          } else if (option.is_ask_for_price) {
                            optionDetails = "Ask For Price";
                          } else if (option.is_call_for_price) {
                            optionDetails = "Call For Price";
                          }

                          if (option.uom) {
                            optionDetails += optionDetails !== "" ? ` - ${option.uom}` : option.uom;
                          }

                          if (option.basis_cd) {
                            optionDetails += optionDetails !== "" ? ` - ${option.basis_cd}` : option.basis_cd;
                          }

                          return (
                            <MenuItem key={option.cost_id} value={option.cost_id}>
                              <Typography variant="body2" color={option.is_discontinued ? "error" : "inherit"}>
                                <b>{option.color_name}</b>
                                <br></br>
                                { hasMultipleDistributors && option.distributor ? (
                                    <>
                                      {option.distributor}
                                      <br></br>
                                    </>
                                  ) : undefined
                                }
                                <span style={{color: option.is_promo_active && !option.is_ask_for_price ? "#f44336" : "inherit"}}>{optionDetails}</span>  
                              </Typography>
                            </MenuItem>
                          )
                        })
                      }
                    </Select>
                  </>
                ) : options[0]?.color_name ? (
                  <>
                    <Typography>
                      <b>Color</b>
                      { hasDiscontinuedOptions ? (
                          <Tooltip 
                            title={
                              <Typography variant="subtitle2">Some options discontinued</Typography> 
                            }
                            aria-label="Some options discontinued"
                            placement="top"
                          >
                            <Info style={{display: "inline-block", verticalAlign: "middle", marginLeft: "5px", color: "#f44336"}}/>
                          </Tooltip>
                        ) : undefined
                      }
                    </Typography>
                    <Typography variant="body2">
                      { 
                        options?.map(option => {

                          let optionDetails = "";

                          if (option.pricing.retail_price) {
                            optionDetails = "$" + option.pricing.retail_price?.toFixed(2);
                          }

                          if (option.is_promo_active) {
                            optionDetails = "$" + option.promotion_pricing.retail_price?.toFixed(2) + " (Promo)";
                          }

                          if (option.uom) {
                            optionDetails += optionDetails !== "" ? ` - ${option.uom}` : option.uom;
                          }

                          if (option.basis_cd) {
                            optionDetails += optionDetails !== "" ? ` - ${option.basis_cd}` : option.basis_cd;
                          }

                          return (
                            <React.Fragment key={option.cost_id}>
                              <b>{option.color_name}</b>
                              <br></br>
                              <span style={{color: option.is_promo_active ? "#f44336" : "inherit"}}>{optionDetails}</span>
                            </React.Fragment> 
                          )
                        })
                      }
                    </Typography>
                  </>
                ) : undefined
              }
              { selectedOption && useCustomCalcFunctions && user?.user_id && (user?.is_hidden || user?.is_admin) ? (
                  <Button
                    size="small" 
                    variant="contained"
                    onClick={() => setIsCalcViewModalOpen(true)}
                    style={{display: "block", backgroundColor: "#00000017", margin: "10px 0px"}}
                  >
                    Show Calculation Flow
                  </Button>
                ) : undefined
              }
              { isRoomCalcAllowed && selectedOption && !selectedOption.is_discontinued && !selectedOption.is_ask_for_price && !selectedOption.is_call_for_price ? (
                  <>
                    <Typography style={{marginTop: "30px"}}><b>Estimated Quantity {selectedOption?.uom ? `(${selectedOption?.uom})` : undefined}</b></Typography>    
                    <Typography variant="subtitle2">{selectedOption?.selling_unit_quantity ? `Sold in quantities of ${selectedOption?.selling_unit_quantity} ${selectedOption?.uom ? `${selectedOption?.uom}` : ''}` : undefined}</Typography>
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      style={{width: "100px"}}
                      value={sizeEstimate.toString()}
                      inputProps={{
                        style: {paddingTop: "10px"}
                      }}
                      onChange={(e) => {
                        if ((e.target.value || '') === '') {
                          setSizeEstimate('');
                          return;
                        }

                        const newQuantity = parseFloat(e.target.value) < 0 ? 0 : parseFloat(e.target.value);
                        setSizeEstimate(newQuantity);
                      }}
                    >
                    </TextField>

                    <Typography style={{marginTop: "15px"}}><b>Estimated Total</b></Typography>
                    {isEstimateRounded ? (
                        <Typography variant="subtitle2">Rounded to {roundedSizeEstimate} {selectedOption?.uom ? `${selectedOption?.uom}` : ''}</Typography>
                      ) : undefined
                    }
                    <Typography 
                      style={{textDecoration: selectedOption?.is_promo_active && roundedSizeEstimate > 0 ? "line-through" : "none", textDecorationColor: "rgba(0,0,0,0.65)"}}
                    >
                      {`$${roundedSizeEstimate ? (currentListPrice * roundedSizeEstimate).toFixed(2) : (0).toFixed(2)}`}
                    </Typography>
                    { selectedOption?.is_promo_active && roundedSizeEstimate > 0 ? (
                        <Typography color="error">{`$${(currentListPromoPrice * roundedSizeEstimate).toFixed(2)}`}</Typography>
                      ) : undefined
                    }
                  </>
                ) : undefined
              }
            </Paper>
            <div style={{marginTop: "20px"}}>
              <Grid container spacing={1} justifyContent="center" style={{marginTop: "10px"}}>             
                { roomvoToggle && isRoomvoLoaded && !roomvoError && selectedOption ? (
                    <Grid item xs={12} sm={6} md={12} lg={6}>
                      <Button 
                        variant="contained"
                        fullWidth
                        style={{backgroundColor: "#FF682C", color: "#FFFFFF"}}
                        onClick={(e) => openRoomvoVisualizer(e)}
                      >
                        Roomvo Visualizer
                      </Button>
                    </Grid>
                  ) : undefined
                }           
              
                { productData?.product_description ? (
                    <Grid item xs={12} sm={6} md={12} lg={6}>
                      <Button 
                        variant="contained" 
                        fullWidth 
                        href={getFormattedExternalUrl(productData?.product_description)} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{backgroundColor: "#142E3E", color: "#28C4FC"}}
                      >
                        <Launch style={{marginRight: "6px"}} /> See product online
                      </Button>
                    </Grid>
                  ) : undefined 
                }
              </Grid>
              <Grid container spacing={1} justifyContent="center" style={{marginTop: "10px"}}>
                { isFavAllowed && selectedOption ? (
                    <Grid item xs={6}>
                      <Button 
                        variant="contained" 
                        fullWidth 
                        style={{backgroundColor: "#FFFFFF", color: isProductSkuLiked ? "red" : "initial"}}
                        onClick={() => onClickfavorite(productData?.product_uuid, selectedOption?.product_sku)} 
                      >
                        <Favorite style={{marginRight: "6px"}}/> {isProductSkuLiked ? 'Liked' : 'Like'}
                      </Button>
                    </Grid>
                  ) : undefined
                }
                { user?.access_type_cd !== 'c' || isCheckoutAllowed ? (
                    <Grid item xs={6}>
                      <SampleCheckouts 
                        areCheckoutsAllowed={isCheckoutAllowed} 
                        user={user} 
                        locationId={locationId}
                        product={productData}
                      />
                    </Grid>
                  ) : undefined
                } 
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <Accordion style={{backgroundColor: "#00000017"}} defaultExpanded> 
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h6" style={{margin: "0px"}}><b>Product Details</b></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container>
                  { user?.access_type_cd !== 'c' && !showCustomerView ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>FOB Origin</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{selectedOption?.fob_origin ? selectedOption?.fob_origin : "--"}</Typography>
                        </Grid>

                        <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>
                      </>
                    ) : undefined
                  }

                  { pageConfig?.show_manufacturer ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>Manufacturer</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{productData?.manufacturer_name ? productData?.manufacturer_name : "--"}</Typography>
                        </Grid>

                        <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>
                      </>
                    ) : undefined
                  }

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2"><b>Distributor</b></Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2">{selectedOption?.distributor ? selectedOption?.distributor : "--"}</Typography>
                  </Grid>

                  <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                  { pageConfig?.show_collection ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>Collection</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{productData?.collection ? productData?.collection : "--"}</Typography>
                        </Grid>

                        <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>
                      </>
                    ) : undefined
                  }
                    

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2"><b>Style Number</b></Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2">{(productData?.private_style ? productData?.private_style : productData?.style) || "--"}</Typography>
                  </Grid>

                  <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2"><b>SKU</b></Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2">{selectedOption?.product_sku ? selectedOption?.product_sku : "--"}</Typography>
                  </Grid>

                  <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                  { ['a'].includes(user?.access_type_cd) && !showCustomerView && currentCostStr !== currentBaseCostStr ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>Base Cost</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{currentBaseCostStr ? currentBaseCostStr : "--"}</Typography>
                        </Grid>

                        <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>
                      </>
                    ) : undefined
                  }

                  { ['a', 'rw'].includes(user?.access_type_cd) && !showCustomerView ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>{['a'].includes(user?.access_type_cd) && currentCostStr !== currentBaseCostStr ? 'Loaded ' : ''}Cost</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{currentCostStr ? currentCostStr : "--"}</Typography>
                        </Grid>

                        <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>
                      </>
                    ) : undefined
                  }

                  { ['a'].includes(user?.access_type_cd) && !showCustomerView && selectedOption?.is_promo_active && currentPromoCostStr !== currentBasePromoCostStr ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>Base Promo Cost</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{currentBasePromoCostStr ? currentBasePromoCostStr : "--"}</Typography>
                        </Grid>

                        <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>
                      </>
                    ) : undefined
                  }

                  { ['a', 'rw'].includes(user?.access_type_cd) && !showCustomerView && selectedOption?.is_promo_active ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>{['a'].includes(user?.access_type_cd) && currentPromoCostStr !== currentBasePromoCostStr ? 'Loaded ' : ''}Promo Cost</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{currentPromoCostStr ? currentPromoCostStr : "--"}</Typography>
                        </Grid>

                        <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>
                      </>
                    ) : undefined
                  }

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2"><b>Material Info</b></Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2">{productData?.material_class ? productData?.material_class : "--"}</Typography>
                    <Typography variant="subtitle2"><i>{productData?.disclaimer}</i></Typography>
                  </Grid>

                  <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2"><b>Unit of Measure</b></Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2">{selectedOption?.uom ? selectedOption?.uom : "--"}</Typography>
                  </Grid>

                  <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2"><b>Selling Unit</b></Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2">{selectedOption?.selling_unit_quantity ? `${selectedOption?.selling_unit_quantity} ${selectedOption?.selling_unit_uom ? selectedOption?.selling_unit_uom : selectedOption?.uom ? selectedOption?.uom : ""}` : "--"}</Typography>
                  </Grid>

                  <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2"><b>Product Disclaimer</b></Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2"><i>{productDisclaimer}</i></Typography>
                  </Grid>

                  <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                  { user?.access_type_cd !== 'c' && !showCustomerView ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2"><b>Last Updated</b></Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2">{formatDttm(selectedOption?.last_modified_dttm, { format: 'M/D/YYYY', fallback: '--' })}</Typography>
                        </Grid>
                      </>
                    ) : undefined
                  }
                </Grid>
              </AccordionDetails>
            </Accordion>
            { pageConfig.show_specs ? (
                <Accordion style={{backgroundColor: "#00000017", margin: "10px 0px 0px"}}> 
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography variant="h6" style={{margin: "0px"}}><b>Product Specs</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2"><b>Sizing</b></Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2">{productData?.size_cd ? productData?.size_cd : "--"}</Typography>
                      </Grid>

                      {productData?.measurements?.length ? (
                          productData.measurements.map(m => {
                            return (
                              <React.Fragment key={m.measurement_type + '-' + m.measurement_type_cd}>
                                <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                                <Grid item xs={12} md={6}>
                                  <Typography variant="body2"><b>{m.measurement_type}</b></Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Typography variant="body2">{m.measurement_value ? m.measurement_value : "--"} {m.uom_type ? ` (${m.uom_type.toLowerCase()})` : ''}</Typography>
                                </Grid>
                              </React.Fragment>
                            )
                          })
                        ) : (
                          <>
                            <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                            <Grid item xs={12} md={6}>
                              <Typography variant="body2"><b>Length</b></Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="body2">{productData?.length ? `${productData?.length} ${productData?.length_uom}` : "--"}</Typography>
                            </Grid>

                            <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                            <Grid item xs={12} md={6}>
                              <Typography variant="body2"><b>Width</b></Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="body2">{productData?.width ? `${productData?.width} ${productData?.width_uom}` : "--"}</Typography>
                            </Grid> 

                            <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                            <Grid item xs={12} md={6}>
                              <Typography variant="body2"><b>Thickness</b></Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="body2">{selectedOption?.thickness ? selectedOption?.thickness : "--"}</Typography>
                            </Grid>    

                            <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                            <Grid item xs={12} md={6}>
                              <Typography variant="body2"><b>Weight (oz)</b></Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="body2">{selectedOption?.ounce_weight ? selectedOption?.ounce_weight : "--"}</Typography>
                            </Grid>   
                            
                            <Grid item xs={12} style={{margin: "3px 0px"}}></Grid>

                            <Grid item xs={12} md={6}>
                              <Typography variant="body2"><b>Wear Layer</b></Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="body2">{selectedOption?.wear_layer ? selectedOption?.wear_layer : "--"}</Typography>
                            </Grid>       
                          </>
                        )
                      }   
                    </Grid>
                  </AccordionDetails>
                </Accordion> 
              ) : undefined
            }
            { productData?.product_image || options.find(o => o.product_sku_image) ? (
                <Accordion style={{backgroundColor: "#00000017", margin: "10px 0px 0px"}}> 
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography variant="h6" style={{margin: "0px"}}><b>Product Images</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      { productData?.product_image ? (
                          <Grid item xs={6} sm={4} md={4} lg={3}>
                            <Card>
                              <CardMedia
                                component="img"
                                image={getFormattedExternalUrl(productData?.product_image)}
                                alt={productData?.trade_name}
                                title={productData?.trade_name}
                              />
                              <CardContent style={{padding: "5px"}}>
                                <Typography>
                                  {productData?.trade_name}
                                </Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                        ) : undefined 
                      }
                      { options?.map(option => {
                        if (!option?.product_sku_image) {
                          return (<React.Fragment key={option.cost_id}></React.Fragment>)
                        }

                        return (
                          <Grid key={option.cost_id} item xs={6} sm={4} md={4} lg={3}>
                            <Card>
                              <CardMedia
                                component="img"
                                image={getFormattedExternalUrl(option?.product_sku_image)}
                                alt={productData?.trade_name + ' - ' + option?.color_name}
                                title={productData?.trade_name + ' - ' + option?.color_name}
                              />
                              <CardContent style={{padding: "5px"}}>
                                <Typography style={{display: "block"}}>
                                  {productData?.trade_name}
                                </Typography>
                                <Typography variant="caption">
                                  {option?.color_name}
                                </Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                        )
                      })}
                    </Grid>
                  </AccordionDetails>
                </Accordion> 
              ) : undefined
            }     
          </Grid>
          <Grid item xs={12}>
            { pageConfig?.show_collection ? (
                <ProductLinkList 
                  productUUID={productData?.product_uuid}
                  sectionName={'Collection'}
                  limit={8}
                  expanded={true}
                  getNextProductGroup={(productUUID, offset, limit) => getCollectionProducts(productUUID, offset, limit)}
                /> 
              ) : undefined 
            }
            { showRelatedProducts ? (
                <ProductLinkList 
                  productUUID={productData?.product_uuid}
                  sectionName={'Related Products and Accessories'}
                  limit={8}
                  expanded={false}
                  getNextProductGroup={(productUUID, offset, limit) => getRelatedProducts(productUUID, offset, limit)}
                />
              ) : undefined
            }
            { showDiscovery ? (
                <ProductLinkList 
                  productUUID={productData?.product_uuid}
                  sectionName={'Other Products You Might Like'}
                  limit={8}
                  expanded={true}
                  getNextProductGroup={(productUUID, offset, limit) => getDiscoveryProducts(productUUID, offset, limit)}
                />
              ) : undefined
            }
          </Grid>
          <Grid item xs={12} style={{textAlign: "center"}}>
            <div className="qrcode">
              <QRcode
                value={`${window.location.href}`}
                size={160}
              />
            </div>
            {(() => {
              const bc = pageConfig?.barcode;
              const raw = bc?.enabled && bc?.sourceColumn ? selectedOption?.[bc.sourceColumn] : null;
              if (raw === undefined || raw === null || raw === "") return null;
              return (
                <div className="barcode" style={{ marginTop: 16 }}>
                  <Barcode
                    value={`${bc.prefix || ""}${raw}`}
                    format={bc.symbology || "CODE128"}
                  />
                </div>
              );
            })()}
          </Grid>
        </Grid>
      </Paper>
      
      <Typography variant="subtitle2" style={{margin: "50px", textAlign: "center"}}>
        <span>&#169;</span> {new Date().getFullYear()} Powered by <a href="https://showroompricing.com" target="_blank" rel="noreferrer noopener" style={{ color: "#000" }}>
          Showroom Pricing</a>.
      </Typography>

      { showVegasMarketing ? (
          <>
            <Fab 
              size="medium" 
              variant="extended" 
              href={"/tradeshow/vegas"}
              style={{zIndex: "29", position: "fixed", width: "calc(100vw - 170px)", maxWidth: "400px", bottom: "0px", left: "0px", padding: "0px 12px", backgroundColor: '#4caf50', color: '#FFFFFF', margin: "20px"}} 
            >
              <Casino fontSize="small" style={{marginRight: "8px"}}/>
              Spin to win!
              <Casino fontSize="small" style={{marginLeft: "8px"}}/>
            </Fab>
          </>
        ) : undefined
      }

      { user?.access_type_cd !== 'c' ? (
          <>
            <Fab 
              size="medium" 
              variant="extended" 
              style={{zIndex: "31", position: "fixed", bottom: "0px", right: "0px", padding: "0px 12px", color: "#28C4FC", backgroundColor: "#142E3E", margin: "20px"}} 
              onClick={() => setShowInternalFunctionsModal(!showInternalFunctionsModal)}
            >
              { showInternalFunctionsModal ? (
                  <>
                    <Close fontSize="medium" style={{marginRight: "5px"}}/> Close
                  </>
                ) : (
                  <>
                    <Settings fontSize="small" style={{marginRight: "5px"}}/> Tools
                  </>
                ) 
              }
            </Fab> 
            <Backdrop 
              open={showInternalFunctionsModal} 
              style={{zIndex: "30"}}
              onClose={() => setShowInternalFunctionsModal(false)}
            >
              <div style={{textAlign: "left", width: "75%", maxWidth: "350px", padding: "10px"}}>
                <Button 
                  size="large" 
                  fullWidth
                  style={{backgroundColor: "#FFFFFF", margin: "0px 0px 20px"}} 
                  onClick={() => {
                    setShowInternalFunctionsModal(false);
                    setShowScannerModal(true);
                  }}
                >
                  <Camera fontSize="small" style={{marginRight: "10px"}}/> 
                  Scan QR
                </Button>
                { user?.access_type_cd === 'a' ? (
                    <>
                      <Button 
                        size="large" 
                        fullWidth
                        style={{backgroundColor: "#FFFFFF", margin: "0px 0px 20px"}} 
                        onClick={() => {
                          setShowInternalFunctionsModal(false);
                          setShowUpdateProductDialog(true);
                        }}
                      >
                        <Edit fontSize="small" style={{marginRight: "10px"}}/> 
                        Edit
                      </Button>
                      <Button 
                        size="large" 
                        fullWidth
                        style={{backgroundColor: "#FFFFFF", margin: "0px 0px 20px"}} 
                        onClick={() => {
                          setShowInternalFunctionsModal(false);
                          setShowStatsDialog(true);
                        }}
                      >
                        <Equalizer fontSize="small" style={{marginRight: "10px"}}/> 
                        Product Stats
                      </Button>
                      <UpdateProductDialog
                        product={productData}
                        isOpen={showUpdateProductDialog}
                        handleOnClose={() => setShowUpdateProductDialog(false)}
                        handleOnSubmit={() => setRefreshPage(true)}
                      />
                      <ProductStatsDialog
                        product={productData}
                        isOpen={showStatsDialog}
                        showLocationSelection={true}
                        showProductPageButton={false}
                        handleOnClose={() => setShowStatsDialog(false)}
                      />
                    </>
                  ) : undefined
                }
                {user?.user_id && user?.access_type_cd !== 'c' ? (
                    <>
                      <Button 
                        size="large" 
                        fullWidth
                        style={{backgroundColor: "#FFFFFF", margin: "0px 0px 20px"}} 
                        onClick={() => {
                          setShowInternalFunctionsModal(false);
                          setShowLeadDialog(true);
                        }}
                      >
                        <People fontSize="small" style={{marginRight: "10px"}}/> 
                        Find/Create Lead
                      </Button>
                      <Button 
                        size="large" 
                        fullWidth
                        style={{backgroundColor: "#FFFFFF", margin: "0px 0px 20px"}} 
                        onClick={() => {
                          setShowInternalFunctionsModal(false);
                          handleUpdatePrintQueue(productData?.product_uuid);
                        }}
                      >
                        <Print fontSize="small" style={{marginRight: "10px"}}/> 
                        Add To Print Queue
                      </Button>
                      <Button
                        size="large" 
                        fullWidth
                        style={{backgroundColor: "#FFFFFF", margin: "0px 0px 20px"}} 
                        onClick={() => {
                          setShowInternalFunctionsModal(false);
                          setShowCustomerView(!showCustomerView)
                        }}
                      >
                        {showCustomerView ? (
                            <>
                              <Visibility fontSize="small" style={{marginRight: "10px"}}/> Show Internal View
                            </>
                          ) : (
                            <>
                              <VisibilityOff fontSize="small" style={{marginRight: "10px"}}/> Show {role.role_name} View
                            </>
                          )
                        }
                      </Button>
                      <Dialog open={showLeadDialog}>
                        <DialogContent>
                          <CreateLeadForm
                            user={user}
                            isOpen={showLeadDialog}
                            formType={'both'}
                            isModal={true}
                            handleOnClose={() => setShowLeadDialog(false)}
                          />
                        </DialogContent>
                      </Dialog>
                    </>
                  ) : undefined
                }
                { useCustomCalcFunctions && user?.user_id && (user?.is_hidden || user?.is_admin) ? (
                    <Button
                      size="large" 
                      fullWidth 
                      onClick={() => setIsCalcViewModalOpen(true)}
                      style={{backgroundColor: "#FFFFFF", margin: "0px 0px 20px"}}
                    >
                      Show Calculation Flow
                    </Button>
                  ) : undefined
                }
                { showVegasMarketing && user?.user_id && user?.is_hidden ? (
                  <>
                    <Button
                      size="large" 
                      fullWidth 
                      variant="contained" 
                      onClick={() => setIsSlotModalOpen(true)}
                      style={{backgroundColor: '#4caf50', color: '#FFFFFF', margin: "0px 0px 20px"}} 
                    >
                      <Casino fontSize="small" style={{marginRight: "8px"}}/>
                      Slot Machine Modal
                      <Casino fontSize="small" style={{marginLeft: "8px"}}/>
                    </Button>
                    <SlotMachine 
                      isOpen={isSlotModalOpen} 
                      onClose={() => {
                        setIsSlotModalOpen(false);
                      }} 
                      isMultiSpin={true}
                    />
                  </>
                ) : undefined
              }
              </div>
            </Backdrop>
          </>
        ) : (
          <Fab size="medium" variant="extended" style={{zIndex: "31", position: "fixed", bottom: "0px", right: "0px", padding: "0px 12px", color: "#28C4FC", backgroundColor: "#142E3E", margin: "20px"}} onClick={() => setShowScannerModal(true)}>
            <Camera fontSize="small" style={{marginRight: "5px"}}/> 
            Scan QR
          </Fab> 
        )
      }

      { useCustomCalcFunctions && user?.user_id && (user?.is_hidden || user?.is_admin) ? (
          <FlowModal 
            isOpen={isCalcViewModalOpen} 
            onClose={() => {
              setIsCalcViewModalOpen(false);
            }} 
            productUUID={productData?.product_uuid}
            roles={roles}
            roleId={role?.role_id}
            options={options}
            user={user}
          />
        ) : undefined
      }

      <SignInAlert isOpen={showSignInAlert} onClose={() => setShowSignInAlert(false)}/>
      <ScanningModal isOpen={showScannerModal} handleOnClose={() => setShowScannerModal(false)}/>
      <Dialog open={dupDialogOpen} onClose={handleDupClose} fullScreen>
        <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: 16 }}>
          <Typography variant="h6">Review Potential Duplicate</Typography>
          <Button variant="outlined" style={{ minWidth: 36, padding: '4px 8px' }} onClick={handleDupClose}>X</Button>
        </DialogTitle>
        <DialogContent dividers>
          {dupProductA && dupProductB && (
            <DuplicateMergeReview
              productA={dupProductA}
              productB={dupProductB}
              keeperUuid={dupKeeperUuid}
              onKeep={setDupKeeperUuid}
              mode="merge"
              scores={duplicateFlag ? {
                style:     duplicateFlag.score_style,
                name:      duplicateFlag.score_name,
                mfg:       duplicateFlag.score_mfg,
                size:      duplicateFlag.score_size,
                composite: duplicateFlag.score,
              } : null}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleDupClose} disabled={dupMerging}>Cancel</Button>
          <Button variant="outlined" onClick={handleDupDismiss} disabled={dupMerging}>Not a Duplicate</Button>
          <Button
            variant="contained"
            style={{ backgroundColor: '#FF682C', color: '#fff' }}
            onClick={handleDupMergeConfirm}
            disabled={!dupKeeperUuid || dupMerging}
          >
            {dupMerging
              ? <><CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} />Merging…</>
              : dupKeeperUuid ? 'Confirm Merge' : 'Select a product to keep'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}